import { axiosRequest } from '@/util/axios-request'
// const method = 'get'
const listUrl = '/web/approval/list'
const exportUrl = '/web/approval/exportList'
const seeUrl = '/web/approval/detail'
const configUrl = '/web/approval/getInfo'
const eSUrl = '/web/approval/exportMore'
const typeUrl = '/web/approval/getBuildInTypes'

// 表格
export const listFn = data => axiosRequest({ url: listUrl, data })

// 导出
export const exportFn = params => axiosRequest({ url: exportUrl, data: params })

// 查看
export const seeFn = data => axiosRequest({ url: seeUrl, data })

// 获取配置
export const configFn = () => axiosRequest({ url: configUrl })

export const exportMore = data => axiosRequest({ url: eSUrl, data })

// 获取时间类型枚举
export const getBuildInTypes = data => axiosRequest({ url: typeUrl })

